import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetReminderWorkflowList({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/reminder_workflow/list?order_by=created_on&order_dir=desc" ,
        params: {
          page: list.page,
          per_page: list.per_page ? list.per_page : 10,
          reminder_workflow_name: list.reminder_workflow_name ? '*' + list.reminder_workflow_name + '*' : ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetReminderWorkflow({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/reminder_workflow/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err)
      });
    });
  },
  AddReminderWorkflow({ commit }, reminderWorkflow) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/reminder_workflow" ,
        data: reminderWorkflow,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      })
      .catch(err => {
        // sreject(err);
      });
    });
  },  
  EditReminderWorkflow({ commit }, reminderWorkflow) {
    return new Promise( (resolve, reject) => {
      axios({
        url: "/reminder_workflow/" + reminderWorkflow.id ,
        data: reminderWorkflow.reminderWorkflow,
        method: "Patch"
      }).then(res => {
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  }, 
  DeleteReminderWorkflow({ commit }, reminderWorkflowId) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/reminder_workflow/" + reminderWorkflowId ,
        method: "DELETE"
      }).then(res => {
        resolve(res.data.payload);
      })
      .catch(err => {
        reject(err);
      });
    });
  }, 
  
};

// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
